import { useMemo } from 'react'

import useReduxAction from '@hooks/useReduxAction'
import useSelector from '@hooks/useSelector'
import useWatchEntityUpdates from '@hooks/useWatchEntityUpdates'

import type { ModuleState } from '@redux/modules/types'

const watchEntityKeys = ['autoOrderQueueStatuses']

type UseAutoOrderQueueStatusesOptions = {
  performHttpRequests?: boolean,
}

function useAutoOrderQueueStatuses(options: UseAutoOrderQueueStatusesOptions) {
  const { performHttpRequests } = options

  const {
    updatedEntities: { autoOrderQueueStatuses: autoOrderQueueStatusesUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { autoOrderQueueStatuses: entityAutoOrderQueueStatuses } = useSelector(reduxState => reduxState.entities)

  const autoOrderQueueStatuses = useMemo(() => Object.values(entityAutoOrderQueueStatuses), [autoOrderQueueStatusesUpdatedAt])

  const { loading: loadingAutoOrderQueueStatuses } = useReduxAction(
    'autoOrderQueueStatuses',
    'loadAutoOrderQueueStatuses',
    {},
    [performHttpRequests],
    {
      shouldPerformFn: ({ loading }: ModuleState) => !!performHttpRequests && !loading,
    },
  )

  return {
    autoOrderQueueStatuses,
    loading: loadingAutoOrderQueueStatuses,
  }
}

export default useAutoOrderQueueStatuses
